export default __webpack_public_path__ + "static/media/Gida of Necrotic Dread.e1a2a55f.jpg";